import { CardBg, CardImage, CardLink, CardSection, CardSpacer } from '@fttb/common/components';
import { connect } from 'react-redux';
import { getTariffBgColor, getTariffHref, getTariffTitle } from "../../../../store/blocks/tariffs/tariffSelectors";
import { onTariffCardClick } from "../../../../store/blocks/tariffs/actions";
import { withAnalyticsOnTariffsBlockView } from "../../../hoc/withAnalyticsOnTariffsBlockView";
import { getTariffsGroup, getTariffsTitle } from "../../../../store/blocks/tariffs/selectors";
import { getAnalyticEventType } from "../../../../store/blocks/selectors";
import { selectCommonAnalyticsData } from "../../../../store/analytics/selectors";
export var TariffCard = function TariffCard(_ref) {
  var children = _ref.children;
  return children;
};
var ConnectedSection = connect(function (state) {
  return {
    background: getTariffBgColor(state)
  };
})(CardSection);
var CardLinkHOC = withAnalyticsOnTariffsBlockView(CardLink);
var ConnectedLink = connect(function (state) {
  return {
    // метод ссылки для конструктора
    href: getTariffHref(state),
    elementTitle: getTariffTitle(state),
    pageType: getAnalyticEventType(state),
    commonAnalyticsData: selectCommonAnalyticsData(state),
    tabName: getTariffsGroup(state),
    blockTitle: getTariffsTitle(state)
  };
}, {
  onClick: onTariffCardClick
})(CardLinkHOC);
TariffCard.Bg = CardBg;
TariffCard.Image = CardImage;
TariffCard.Spacer = CardSpacer;
TariffCard.Section = ConnectedSection;
TariffCard.Link = ConnectedLink;